import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';

interface IRealtorCatalogLinkMobile {
  onLinkClick: () => void;
}

export const RealtorCatalogLinkMobile: React.FunctionComponent<React.PropsWithChildren<IRealtorCatalogLinkMobile>> = ({
  onLinkClick,
}) => (
  <LinkButton
    href="/agents"
    size="M"
    fullWidth
    theme="fill_secondary"
    data-testid="catalog_link_mobile"
    onClick={onLinkClick}
  >
    В каталог риелторов
  </LinkButton>
);
